export default function Divider({ light }: { light: Boolean }) {
  return <div className="h-px w-full bg-scale-400"></div>
}
